//#region Services
import { eventsSessionStorage } from "services/storage/events";
import {
	requestCreateEvent,
	requestUpdateEventById,
} from "services/events/aboutEvents";
//#endregion
//#region Utils
import useMainContext from "utils/context/useMainContext";
import { TYPES } from "../../reducer/event.actions";
import validator from "../validations";
import { ALLOW_DURATION_EVENT_UPDATE } from "config/deploymentMode";
import { EVENTS_CONSTANTS } from "config/constants";
import useCheckNonExpiredDuration from "./useCheckNonExpiredDuration";
//#endregion

const { EVENT_PERIOD_IDS } = EVENTS_CONSTANTS;

const useEventFormActions = ({
	loadingRequest,
	form, nextStep, toStep,
	teacherZoomAccountDetail,
	errors, changeErrorsStep,
	setMustCorrect, setShowDialogUpdatedEvent,
	showToastMessageSaveEventAsDraft,
	changeErrorText, eventResumeData,
	isCompletedForm, setCanShowDialogLeavingPage,
	dialogShowErrorVacantCapacityForGreaterThanTheLimit,
	currentStep, showDialogSchedulesWithCrossings
}) => {
	const mainContext = useMainContext();
	const fillErrorTeacher = (result, message) => {
		if (form.step2.part1.teacher.search.id) {
			result.newErrors.part1.teacher.search = true;
			changeErrorText("teacherSearch", message);
		}
		else {
			result.newErrors.part1.teacher.free.accountId = true;
			changeErrorText("teacherFreeAccount", message);
		}
		changeErrorsStep(TYPES.SET_FORM_ERRORS_STEP_2, result.newErrors);
	};
	function manageResultRequestSaveEvent(isValid) {
		if (typeof isValid === "undefined") return;
		if (isValid === null) {
			mainContext.setShowDialogUnexpectedError(true);
			return;
		}
		if (!isValid) {
			setMustCorrect(true);
			setTimeout(() => {
				setMustCorrect(false);
			}, 2400);
		} else setCanShowDialogLeavingPage(false);
		window.scrollTo({ top: 0, behavior: "smooth" });
	}
	function ignoreDurationFieldsInUpdateIfIsNotDraft() {
		if (ALLOW_DURATION_EVENT_UPDATE) return false;
		const isDraft = eventsSessionStorage.isDraftEvent.get();
		return {
			onlyDay:
				!isDraft &&
				eventResumeData.value?.step1.duration.period ===
					EVENT_PERIOD_IDS.MANY_DAYS,
			manyDays: !isDraft && eventResumeData.value?.step1.duration.period,
		};
	}
	function manageErrorMessageOfStep1({ success, message }) {
		const {
			FORM_ACTION_ERROR_CODES,
			FORM_ERROR_TEXT_LIST_PER_FORM_ACTION_ERROR_CODE,
		} = EVENTS_CONSTANTS;
		switch (message) {
			case FORM_ACTION_ERROR_CODES.CROSS_SCHEDULE:
			case FORM_ACTION_ERROR_CODES.CROSS_SCHEDULE_PS:
			case FORM_ACTION_ERROR_CODES.CREATE_EVENT_ERROR_PS:
			case FORM_ACTION_ERROR_CODES.UPDATE_EVENT_PS:
			case FORM_ACTION_ERROR_CODES.NO_TEACHER_EMPLID_PS:  {
				const errorText = FORM_ERROR_TEXT_LIST_PER_FORM_ACTION_ERROR_CODE[message];
				mainContext.setDialogUnexpectedErrorMessage(errorText);
				return null;
			}
			default:
				if (!success) return null;
		}
		return true;
	}
	async function manageErrorMessageOfStep2(data, result) {
		const { success, message, schedulesWithCrossings } = data;
		const {
			FORM_ACTION_ERROR_CODES,
			FORM_ERROR_TEXT_LIST_PER_FORM_ACTION_ERROR_CODE,
		} = EVENTS_CONSTANTS;
		switch (message) {
			case FORM_ACTION_ERROR_CODES.INVALID_CODE: {
				result.newErrors.part3.publicLoad.list.studentsFile = true;
				changeErrorText(
					"publicLoadStudentsFile",
					"Alguno de los códigos no existe, revísalo y súbelo nuevamente"
				);
				changeErrorsStep(
					TYPES.SET_FORM_ERRORS_STEP_2,
					result.newErrors
				);
				return false;
			}
			case FORM_ACTION_ERROR_CODES.NO_RECORDS: {
				result.newErrors.part3.publicLoad.list.studentsFile = true;
				changeErrorText(
					"publicLoadStudentsFile",
					"El archivo subido no contiene estudiantes para agregar, revísalo y súbelo nuevamente"
				);
				changeErrorsStep(
					TYPES.SET_FORM_ERRORS_STEP_2,
					result.newErrors
				);
				return false;
			}
			case FORM_ACTION_ERROR_CODES.INCORRECT_VACANT_CAPACITY: {
				dialogShowErrorVacantCapacityForGreaterThanTheLimit.toggle();
				return false;
			}
			case FORM_ACTION_ERROR_CODES.ACCOUNT_WEBINAR_CANNOT_UPDATE_ANOTHER_ACCOUNT_TYPE: {
				result.newErrors.part2.zoomTypeId = true;
				changeErrorText(
					"zoomTypeId",
					"Las cuentas webinar no pueden actualizarse a otro tipo de reunión o a otra cuenta."
				);
				changeErrorsStep(
					TYPES.SET_FORM_ERRORS_STEP_2,
					result.newErrors
				);
				return false;
			}
			case FORM_ACTION_ERROR_CODES.TEACHER_EMAIL_NOT_EXISTS:
			case FORM_ACTION_ERROR_CODES.INVALID_INVITATION_OF_ZOOM_ACCOUNT:
			case FORM_ACTION_ERROR_CODES.PENDING_INVITATION_OF_ZOOM_ACCOUNT:
			case FORM_ACTION_ERROR_CODES.LIMIT_EXCEEDED:
			case FORM_ACTION_ERROR_CODES.INACTIVE_TEACHER_ACCOUNT: {
				const errorText = FORM_ERROR_TEXT_LIST_PER_FORM_ACTION_ERROR_CODE[message];
				fillErrorTeacher(result, errorText);
				return false;
			}
			case FORM_ACTION_ERROR_CODES.UNEXPECTED_ERROR:
				return null;
			case FORM_ACTION_ERROR_CODES.CROSS_SCHEDULE:
			case FORM_ACTION_ERROR_CODES.CROSS_SCHEDULE_PS:
			case FORM_ACTION_ERROR_CODES.UPDATE_EVENT_PS:
			case FORM_ACTION_ERROR_CODES.NO_TEACHER_EMPLID_PS: {
				const errorText = FORM_ERROR_TEXT_LIST_PER_FORM_ACTION_ERROR_CODE[message];
				if (schedulesWithCrossings) {
					showDialogSchedulesWithCrossings(schedulesWithCrossings);
					// Se retorna undefined para cancelar la apertura del diálogo de error inesperado
					return undefined;
				}
				mainContext.setDialogUnexpectedErrorMessage(errorText);
				return null;
			}
			default:
				if (!success) return null;
		}
		return true;
	}
	const checkNonExpiredDuration = useCheckNonExpiredDuration({ form });
	const saveEventData = async loadingMessage => {
		loadingRequest.show(loadingMessage);
		const eventId = eventsSessionStorage.eventId.get();
		let isValid = null;
		let scrollToTop = true;
		switch (currentStep) {
			case 1: {
				const ignoreDurationFields = ignoreDurationFieldsInUpdateIfIsNotDraft();
				const result = validator.isValidFormStep1(
					form.step1,
					errors,
					ignoreDurationFields
				);
				changeErrorsStep(
					TYPES.SET_FORM_ERRORS_STEP_1,
					result.newErrors
				);
				isValid = result.isValid;
				if (!isValid) break;
				if (!checkNonExpiredDuration()) {
					loadingRequest.hide();
					isValid = undefined;
					return;
				}
				if (eventId) {
					const data = await requestUpdateEventById(
						eventId,
						form.step1,
						"step1",
						ignoreDurationFields
					);
					isValid = manageErrorMessageOfStep1(data);
				} else {
					const newEventId = await requestCreateEvent(form.step1);
					if (!newEventId) {
						isValid = null;
						break;
					}
					eventsSessionStorage.eventId.set(newEventId);
					eventsSessionStorage.isDraftEvent.set(true);
				}
				break;
			}
			case 2: {
				const result = validator.isValidFormStep2(form.step2, {
					teacherZoomAccountDetail,
					eventTypeId: form.step1.part2.eventTypeId,
				});
				changeErrorText(
					"publicLoadStudentsFile",
					"Es necesario que subas un archivo"
				);
				changeErrorText("teacherSearch", null);
				changeErrorText("teacherFreeAccount", "No has seleccionado una cuenta.");
				changeErrorsStep(
					TYPES.SET_FORM_ERRORS_STEP_2,
					result.newErrors
				);
				isValid = result.isValid;
				if (!isValid) break;
				const data = await requestUpdateEventById(
					eventId,
					form.step2,
					"step2"
				);
				if (
					data.message ===
					EVENTS_CONSTANTS.FORM_ACTION_ERROR_CODES
						.INCORRECT_VACANT_CAPACITY
				)
					scrollToTop = false;
				isValid = await manageErrorMessageOfStep2(data, result);
				break;
			}
			default:
				return false;
		}
		if (scrollToTop) manageResultRequestSaveEvent(isValid);
		loadingRequest.hide();
		return isValid;
	};
	const saveAndContinue = async () => {
		const isValid = await saveEventData("Guardando...");
		if (!isValid) return;
		const isCompleted = isCompletedForm(form);
		if (isCompleted.step2) {
			toStep(3);
			await eventResumeData.fill();
		} else if (isCompleted.step1) toStep(2);
		showToastMessageSaveEventAsDraft();
	};
	const saveEventAsDraft = async () => {
		const isValid = await saveEventData("Guardando...");
		if (!isValid) return;
		showToastMessageSaveEventAsDraft();
	};
	const updateEventStep = async () => {
		const isValid = await saveEventData("Actualizando tu evento creado...");
		if (!isValid) return;
		if (eventsSessionStorage.isDraftEvent.get()) {
			nextStep();
			currentStep === 1 && nextStep();
			return;
		}
		setShowDialogUpdatedEvent(true);
	};
	return {
		saveAndContinue,
		saveEventAsDraft,
		updateEventStep,
	};
};

export default useEventFormActions;
